export default {
  name: 'smartkey',
  type: 'detail',
  active: false,
  data: {
    size: 32,
    align: 'center',
    remotekey: false
  }
}
